module.exports = __webpack_public_path__ + "static/img/gpt2.6982185f.jpg";